import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { Observable, map } from 'rxjs';
import { PRIMARY_SOURCE_IDS, ReviewSourceInfoMap } from '../types';
import { ReviewSourceSelectionService } from '../source-selection.service';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyPopoverModule, PopoverPositions } from '@vendasta/galaxy/popover';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'reviews-selected-sources-display',
  imports: [CommonModule, GalaxyAvatarModule, MatIconModule, GalaxyPopoverModule, TranslateModule],
  templateUrl: './selected-sources-display.component.html',
  styleUrls: ['./selected-sources-display.component.scss', '../source-selection-shared-styles.scss'],
})
export class SelectedSourcesDisplayComponent implements OnChanges {
  @Input() selectedSources: string[];
  @Input() shouldFilter: boolean;
  @Input() infoIconForBBB?: boolean = false;
  reviewSourceInfoMap$: Observable<ReviewSourceInfoMap>;
  protected PopoverPositions = PopoverPositions;
  protected showPopover = false;

  sortedSelectedSources: string[] = [];

  constructor(private reviewSourceSelectionService: ReviewSourceSelectionService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shouldFilter) {
      this.updateReviewSourceInfo();
    }

    if (changes.selectedSources) {
      // Sort the selected source info so that primary sources come first and in the order they appear in PRIMARY_SOURCE_IDS
      this.sortedSelectedSources = this.selectedSources.sort((a, b) => {
        const aIsPrimary = PRIMARY_SOURCE_IDS[a];
        const bIsPrimary = PRIMARY_SOURCE_IDS[b];
        const primarySourceIds = Object.keys(PRIMARY_SOURCE_IDS);

        if (aIsPrimary && bIsPrimary) {
          // If both are primary, sort based on their index in PRIMARY_SOURCE_IDS
          return primarySourceIds.indexOf(a) - primarySourceIds.indexOf(b);
        } else if (aIsPrimary && !bIsPrimary) {
          return -1;
        } else if (!aIsPrimary && bIsPrimary) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  protected showPopovers(): void {
    this.showPopover = true;
  }

  protected hidePopovers(): void {
    this.showPopover = false;
  }

  private updateReviewSourceInfo(): void {
    const source$ = this.shouldFilter
      ? this.reviewSourceSelectionService.reviewSourcesWithURLs$
      : this.reviewSourceSelectionService.reviewSources$;
    this.reviewSourceInfoMap$ = source$.pipe(map((reviewSources) => reviewSources.sourceInfo));
  }
}
